/* istanbul ignore file */

import { getPadraoComRetorno, postPadraoComRetorno, putPadraoComRetorno } from 'services/api';
import {
  duckTodosFormularios,
  duckDadosDetalhar,
  duckDadosGrafico,
  duckDadosCard,
  duckNovoReatendimento,
} from 'store/ducks/formulario';
import { ID_REQUERIMENTO_DETALHAR } from 'utils/consts';
import { montarUrlFiltro } from 'utils/funcaoPadrao';
import { detalharRequerimento } from 'routes/paths';

export const fetchGetFormularios = (page, itemsByPage) => dispatch => {
  const url = `Formulario/page=${page}&itemsByPage=${itemsByPage}`;
  dispatch(getPadraoComRetorno(url, true)).then(retorno => dispatch(duckTodosFormularios(retorno)));
};

export const fetchGetFormulariosByFilter = (filtro, page, itemsByPage) => dispatch => {
  const url = montarUrlFiltro(`Formulario/page=${page}&itemsByPage=${itemsByPage}`, filtro);
  dispatch(getPadraoComRetorno(url, true)).then(retorno => dispatch(duckTodosFormularios(retorno)));
};

export const fetchSalvarFormulario = dadosRequest => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `Formulario/InserirFormulario`;
    dispatch(postPadraoComRetorno(url, dadosRequest))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};

export const fetchDetalharFormularioPorId = (id, history) => dispatch => {
  const url = `Formulario/${id}`;
  dispatch(getPadraoComRetorno(url)).then(retorno => {
    dispatch(duckDadosDetalhar(retorno));
    localStorage.setItem(ID_REQUERIMENTO_DETALHAR, id);
    if (history) history.push(detalharRequerimento);
  });
};

export const fetchBuscarFormularioPorLocalizador = (
  localizador,
  documento,
  captchaId,
  userEnteredCaptchaCode
) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(
      getPadraoComRetorno(
        `Formulario/GetByLocalizador?localizador=${localizador}&documento=${documento}&captchaId=${captchaId}&userEnteredCaptchaCode=${userEnteredCaptchaCode}`
      )
    )
      .then(retorno => {
        dispatch(duckDadosDetalhar(retorno));
        resolve(retorno);
      })
      .catch(error => reject(error));
  });
};

export const fetchAdicionarJustificativa = justificativa => dispatch => {
  const url = `Formulario/AlterarFormulario`;
  return new Promise((resolve, reject) => {
    dispatch(postPadraoComRetorno(url, justificativa, false))
      .then(retorno => resolve(retorno))
      .catch(error => reject(error));
  });
};

export const fetchAlterarStatusFormulario = (id, status) => dispatch => {
  const url = `Formulario/AlterarStatus?formularioId=${id}&statusId=${status}`;
  return new Promise((resolve, reject) => {
    dispatch(postPadraoComRetorno(url, null))
      .then(retorno => resolve(retorno))
      .catch(error => reject(error));
  });
};

export const fetchRetornarParaAtendente = (id, status) => dispatch => {
  const url = `Formulario/RetornarParaAtendente?formularioId=${id}&statusId=${status}`;
  return new Promise((resolve, reject) => {
    dispatch(postPadraoComRetorno(url, null))
      .then(retorno => resolve(retorno))
      .catch(error => reject(error));
  });
};

export const fetchBuscarGraficoSupervisor = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno(`Formulario/TotalizadorDiario`))
      .then(retorno => {
        dispatch(duckDadosGrafico(retorno));
        resolve(retorno);
      })
      .catch(error => reject(error));
  });
};

export const fetchBuscarCardAtendente = idAtendente => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno(`Formulario/QuantidadeAberto/${idAtendente}`))
      .then(retorno => {
        dispatch(duckDadosCard(retorno));
        resolve(retorno);
      })
      .catch(error => reject(error));
  });
};

export const fetchVerificarReatendimento = idAtendente => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno(`Formulario/verificarReatendimento/${idAtendente}`))
      .then(retorno => {
        dispatch(duckNovoReatendimento(retorno));
        resolve(retorno);
      })
      .catch(error => reject(error));
  });
};

export const fetchEncaminharRequerimento = objetoEncaminhar => dispatch => {
  const url = `Formulario/AlterarStatusAtendenteSetorial`;
  return new Promise((resolve, reject) => {
    dispatch(postPadraoComRetorno(url, objetoEncaminhar))
      .then(retorno => resolve(retorno))
      .catch(error => reject(error));
  });
};
export const fetchRetornarAtendimento = objetoRetorno => dispatch => {
  const url = `Formulario/Retornar`;
  return new Promise((resolve, reject) => {
    dispatch(putPadraoComRetorno(url, objetoRetorno))
      .then(retorno => resolve(retorno))
      .catch(error => reject(error));
  });
};

export const fetchVerificarDuplicidade = (servicoId, documento) => dispatch => {
  const url = `Formulario/VerificarOcorrencia?documento=${documento}&solicitacaoId=${servicoId}`;
  return new Promise((resolve, reject) => {
    dispatch(getPadraoComRetorno(url))
      .then(retorno => resolve(retorno))
      .catch(error => reject(error));
  });
};

export const fetchAlterarStatusSetorial = dadosRequest => dispatch => {
  const url = `Formulario/AlterarStatusAtendenteSetorial`;
  return new Promise((resolve, reject) => {
    dispatch(postPadraoComRetorno(url, dadosRequest))
      .then(retorno => resolve(retorno))
      .catch(error => reject(error));
  });
};
